export const VERSION_INFO = {
    version: "V2.0",
    commit: "(34c2b3b0)",
    buildDate: "24-02-2026"
};